import apiClient from './client'

export interface WifiClient {
  id: number
  network_id: number
  device_instance_id: number | null
  client_name: string
  ip_last_octet: number | null
  mac_address: string | null
  note: string | null

  // Поля привязанного прибора
  device_position_label?: string | null
  electrical_panel_id?: number | null
  device_name?: string | null
  manufacturer?: string | null
  specification_name?: string | null
  specification_id?: number | null
}

export const getNetworkWifiClients = async (networkId: number): Promise<WifiClient[]> => {
  const response = await apiClient.get('/api/network_wifi_clients', {
    params: { network_id: networkId }
  })
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to fetch wifi clients')
}

export const createWifiClient = async (
  data: Omit<WifiClient, 'id'>
): Promise<{ id: number }> => {
  const response = await apiClient.post('/api/network_wifi_clients', data)
  if (response && response.data && typeof response.data === 'object' && 'id' in response.data) {
    return response.data as { id: number }
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to create wifi client')
}

export const updateWifiClient = async (
  id: number,
  data: Omit<Partial<WifiClient>, 'id' | 'network_id'>
): Promise<void> => {
  await apiClient.put(`/api/network_wifi_clients/${id}`, data)
}

export const deleteWifiClient = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/network_wifi_clients/${id}`)
}
